module.exports = __webpack_public_path__ + "img/icon-tianjia2.393f84aa.svg";